import styled from 'styled-components';
import media from '../../../utils/styling/media';

export const StyledHeader = styled.header`
  min-width: ${({ theme }) => theme.layout.minContentWidth}px;
  background: ${({ theme }) => theme.colors.primary};
`;

export const StyledHeaderContainer = styled.div`
  box-sizing: border-box;
  max-width: ${({ theme }) => theme.layout.maxHeaderContentWidth || theme.layout.maxContentWidth + 16}px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.layout.appHeaderPadding}px;
  min-height: ${({ theme }) => theme.layout.minAppHeaderHeight}px;
  
  ${media.lg`
    min-height: ${({ theme }) => theme.layout.lgMinAppHeaderHeight}px;
  `}
`;
